export enum RequestActions {
  Next,
  Back,
  SaveAsDraft,
  SaveTemplate,
  ShowRequestTemplateForm,
  InitiateReleaseRequest,
  Pay,
  PayLater,
  SubmitInitiatorAction,
  SubmitThirdPartyAction,
  SubmitOwnerAction,
}
